import { useTranslation } from "react-i18next";
import { type WorkflowStepStatus, WorkflowStepStatuses } from "~/api/types";
import { Badge } from "~/atoms/badge";
import { cn } from "~/lib/utils";

type StatusBadgeProps = {
  status: WorkflowStepStatus;
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge
      className={cn("whitespace-nowrap", {
        "bg-emerald-700 text-white": status === WorkflowStepStatuses.completed,
        "bg-blue-700 text-white": status === WorkflowStepStatuses.active,
        "text-muted-foreground": status === WorkflowStepStatuses.upcoming,
      })}
      variant={status === WorkflowStepStatuses.upcoming ? "outline" : undefined}
    >
      {status === WorkflowStepStatuses.completed &&
        t(($) => $.commons.workflow.completed)}
      {status === WorkflowStepStatuses.active &&
        t(($) => $.commons.workflow.inProgress)}
      {status === WorkflowStepStatuses.upcoming &&
        t(($) => $.commons.workflow.notStarted)}
    </Badge>
  );
}
